import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPersistedTotalChats($partnerId: ID!) {
    community(id: $partnerId) {
      id
      stats {
        totalChats
      }
    }
  }
`);
